import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import NewHead from "./landing/NewHead";

function Home() {
  return (
    <div className="newpage">
      <header>
        <Helmet>
          <meta name="robots" content="noindex"></meta>
        </Helmet>
        <NewHead />
      </header>
      <div className="paddin_immner">
        <main className=" carer_page">
          <div className="career_banner career_banner_new">
            <div className="bg-overlay"></div>
            <div className="container">
              <div className="row">
                <div className="col-lg-12 sucesss_page_hg1">
                  <h1>Thanks for choosing Beleaf Technologies.</h1>
                  <p>We will get in touch with you shortly!</p>
                  <div className="pt-3 pb-0 mt-1 banner_text_section">
                    <Link to="/">
                      <Button className="m-0"> Back to home</Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Home;
